module.exports = __webpack_public_path__ + "static/doctors-ae5b5914c01a33d020ae22a690b6641b.jpg";